import {z} from 'zod';

import {
  FileOperationResponseBodySchema,
  UuidResponseBodySchema,
  VehiclePhotoCategorySchema,
  BigDecimalSchema,
  MoneySchema,
  Alpha3Schema,
} from '@dms/api/shared';

export type CreateCostApiResponseSaleVehiclePhoto =
  /** status 201  */ CostResponseBodySaleVehiclePhoto;
export const CreateCostRequestBodySchemaSaleVehiclePhoto = z.object({
  name: z.string(),
  expectedPriceWithoutVat: MoneySchema.nullable(),
  realPriceWithoutVat: MoneySchema.nullable(),
  note: z.string().nullable(),
  fileId: z.string().nullable(),
  category: z.string().nullable(),
  businessCaseId: z.string().nullish(),
});
export type CreateCostRequestBodySaleVehiclePhoto = z.infer<
  typeof CreateCostRequestBodySchemaSaleVehiclePhoto
>;
export const CreateCostApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
  body: CreateCostRequestBodySchemaSaleVehiclePhoto,
});
export type CreateCostApiArgSaleVehiclePhoto = z.infer<
  typeof CreateCostApiArgSchemaSaleVehiclePhoto
>;
export const DeleteCostApiResponseSchemaSaleVehiclePhoto = z.unknown();
export type DeleteCostApiResponseSaleVehiclePhoto = z.infer<
  typeof DeleteCostApiResponseSchemaSaleVehiclePhoto
>;
export const DeleteCostApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
  costId: z.string(),
});
export type DeleteCostApiArgSaleVehiclePhoto = z.infer<
  typeof DeleteCostApiArgSchemaSaleVehiclePhoto
>;
export type EditCostApiResponseSaleVehiclePhoto =
  /** status 200  */ CostResponseBodySaleVehiclePhoto;
export const EditCostRequestBodySchemaSaleVehiclePhoto = z.object({
  name: z.string(),
  expectedPriceWithoutVat: MoneySchema.nullable(),
  realPriceWithoutVat: MoneySchema.nullable(),
  note: z.string().nullable(),
  fileId: z.string().nullable(),
  category: z.string().nullable(),
});
export type EditCostRequestBodySaleVehiclePhoto = z.infer<
  typeof EditCostRequestBodySchemaSaleVehiclePhoto
>;
export const EditCostApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
  costId: z.string(),
  body: EditCostRequestBodySchemaSaleVehiclePhoto,
});
export type EditCostApiArgSaleVehiclePhoto = z.infer<typeof EditCostApiArgSchemaSaleVehiclePhoto>;
export const CostResponseBodySchemaSaleVehiclePhoto = z.object({
  id: z.string(),
  name: z.string(),
  expectedPriceWithoutVat: MoneySchema.nullable(),
  realPriceWithoutVat: MoneySchema.nullable(),
  note: z.string().nullable(),
  fileId: z.string().nullable(),
  fileName: z.string().nullable(),
  fileUri: z.string().nullable(),
  createdAt: z.string(),
  category: z.string().nullable(),
});
export type CostResponseBodySaleVehiclePhoto = z.infer<
  typeof CostResponseBodySchemaSaleVehiclePhoto
>;
export const GetCostApiResponseSchemaSaleVehiclePhoto = CostResponseBodySchemaSaleVehiclePhoto;
export type GetCostApiResponseSaleVehiclePhoto = z.infer<
  typeof GetCostApiResponseSchemaSaleVehiclePhoto
>;
export const GetCostApiArgSchemaSaleVehiclePhoto = z.object({
  costId: z.string(),
});
export type GetCostApiArgSaleVehiclePhoto = z.infer<typeof GetCostApiArgSchemaSaleVehiclePhoto>;
export const EarningResponseBodySchemaSaleVehiclePhoto = z.object({
  id: z.string(),
  name: z.string(),
  expectedPriceWithoutVat: MoneySchema.nullable(),
  realPriceWithoutVat: MoneySchema.nullable(),
  note: z.string().nullable(),
  fileId: z.string().nullable(),
  fileName: z.string().nullable(),
  fileUri: z.string().nullable(),
  createdAt: z.string(),
});
export type EarningResponseBodySaleVehiclePhoto = z.infer<
  typeof EarningResponseBodySchemaSaleVehiclePhoto
>;
export const CreateEarningApiResponseSchemaSaleVehiclePhoto =
  EarningResponseBodySchemaSaleVehiclePhoto;
export type CreateEarningApiResponseSaleVehiclePhoto = z.infer<
  typeof CreateEarningApiResponseSchemaSaleVehiclePhoto
>;
export const CreateEarningRequestBodySchemaSaleVehiclePhoto = z.object({
  name: z.string(),
  expectedPriceWithoutVat: MoneySchema.nullable(),
  realPriceWithoutVat: MoneySchema.nullable(),
  note: z.string().nullable(),
  fileId: z.string().nullable(),
  businessCaseId: z.string().nullish(),
});
export type CreateEarningRequestBodySaleVehiclePhoto = z.infer<
  typeof CreateEarningRequestBodySchemaSaleVehiclePhoto
>;
export const CreateEarningApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
  body: CreateEarningRequestBodySchemaSaleVehiclePhoto,
});
export type CreateEarningApiArgSaleVehiclePhoto = z.infer<
  typeof CreateEarningApiArgSchemaSaleVehiclePhoto
>;
export const DeleteEarningApiResponseSchemaSaleVehiclePhoto = z.unknown();
export type DeleteEarningApiResponseSaleVehiclePhoto = z.infer<
  typeof DeleteEarningApiResponseSchemaSaleVehiclePhoto
>;
export const DeleteEarningApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
  earningId: z.string(),
});
export type DeleteEarningApiArgSaleVehiclePhoto = z.infer<
  typeof DeleteEarningApiArgSchemaSaleVehiclePhoto
>;
export const EditEarningApiResponseSchemaSaleVehiclePhoto =
  EarningResponseBodySchemaSaleVehiclePhoto;
export type EditEarningApiResponseSaleVehiclePhoto = z.infer<
  typeof EditEarningApiResponseSchemaSaleVehiclePhoto
>;
export const EditEarningRequestBodySchemaSaleVehiclePhoto = z.object({
  name: z.string(),
  expectedPriceWithoutVat: MoneySchema.nullable(),
  realPriceWithoutVat: MoneySchema.nullable(),
  note: z.string().nullable(),
  fileId: z.string().nullable(),
});
export type EditEarningRequestBodySaleVehiclePhoto = z.infer<
  typeof EditEarningRequestBodySchemaSaleVehiclePhoto
>;
export const EditEarningApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
  earningId: z.string(),
  body: EditEarningRequestBodySchemaSaleVehiclePhoto,
});
export type EditEarningApiArgSaleVehiclePhoto = z.infer<
  typeof EditEarningApiArgSchemaSaleVehiclePhoto
>;
export const GetEarningApiResponseSchemaSaleVehiclePhoto =
  EarningResponseBodySchemaSaleVehiclePhoto;
export type GetEarningApiResponseSaleVehiclePhoto = z.infer<
  typeof GetEarningApiResponseSchemaSaleVehiclePhoto
>;
export const GetEarningApiArgSchemaSaleVehiclePhoto = z.object({
  earningId: z.string(),
});
export type GetEarningApiArgSaleVehiclePhoto = z.infer<
  typeof GetEarningApiArgSchemaSaleVehiclePhoto
>;
export const FinanceSummaryResponseBodySchemaSaleVehiclePhoto = z.object({
  expectedTotalEarningsWithoutVat: MoneySchema,
  expectedTotalCostsWithoutVat: MoneySchema,
  expectedMarginWithoutVat: MoneySchema,
  realTotalEarningsWithoutVat: MoneySchema,
  realTotalCostsWithoutVat: MoneySchema,
  realMarginWithoutVat: MoneySchema,
  expectedTotalNetCostsWithoutVat: MoneySchema,
});
export type FinanceSummaryResponseBodySaleVehiclePhoto = z.infer<
  typeof FinanceSummaryResponseBodySchemaSaleVehiclePhoto
>;
export const GetFinanceSummaryApiResponseSchemaSaleVehiclePhoto =
  FinanceSummaryResponseBodySchemaSaleVehiclePhoto;
export type GetFinanceSummaryApiResponseSaleVehiclePhoto = z.infer<
  typeof GetFinanceSummaryApiResponseSchemaSaleVehiclePhoto
>;
export const GetFinanceSummaryApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
});
export type GetFinanceSummaryApiArgSaleVehiclePhoto = z.infer<
  typeof GetFinanceSummaryApiArgSchemaSaleVehiclePhoto
>;
export const ChangeBranchSaleVehicleApiResponseSchemaSaleVehiclePhoto = z.unknown();
export type ChangeBranchSaleVehicleApiResponseSaleVehiclePhoto = z.infer<
  typeof ChangeBranchSaleVehicleApiResponseSchemaSaleVehiclePhoto
>;
export const ChangeBranchSaleVehicleRequestBodySchemaSaleVehiclePhoto = z.object({
  branchId: z.string(),
});
export type ChangeBranchSaleVehicleRequestBodySaleVehiclePhoto = z.infer<
  typeof ChangeBranchSaleVehicleRequestBodySchemaSaleVehiclePhoto
>;
export const ChangeBranchSaleVehicleApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
  changeBranchSaleVehicleRequestBody: ChangeBranchSaleVehicleRequestBodySchemaSaleVehiclePhoto,
});
export type ChangeBranchSaleVehicleApiArgSaleVehiclePhoto = z.infer<
  typeof ChangeBranchSaleVehicleApiArgSchemaSaleVehiclePhoto
>;

export const ChangeSaleVehicleStateToSellApiResponseSchemaSaleVehiclePhoto = z.unknown();
export type ChangeSaleVehicleStateToSellApiResponseSaleVehiclePhoto = z.infer<
  typeof ChangeSaleVehicleStateToSellApiResponseSchemaSaleVehiclePhoto
>;
export const ChangeSaleVehicleStateToSellApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
});
export type ChangeSaleVehicleStateToSellApiArgSaleVehiclePhoto = z.infer<
  typeof ChangeSaleVehicleStateToSellApiArgSchemaSaleVehiclePhoto
>;
export const SaleVehicleFinancialIndicatorsResponseBodySchemaSaleVehiclePhoto = z.object({
  realSellingPrice: MoneySchema.nullable(),
  realSellingPriceWithoutVat: MoneySchema.nullable(),
  discount: MoneySchema.nullable(),
  upsell: MoneySchema.nullable(),
  realCosts: MoneySchema.nullable(),
  realEarnings: MoneySchema.nullable(),
  expectedCosts: MoneySchema.nullable(),
  expectedEarnings: MoneySchema.nullable(),
  expectedAndRealCostsDifference: MoneySchema.nullable(),
  expectedAndRealEarningsDifference: MoneySchema.nullable(),
  expectedTotalGrossMargin: MoneySchema.nullable(),
  expectedVehicleGrossMargin: MoneySchema.nullable(),
  vehicleGrossMargin: MoneySchema.nullable(),
  vehicleGrossMarginPercent: z.string().nullable(),
  totalGrossMargin: MoneySchema.nullable(),
  totalGrossMarginPercent: z.string().nullable(),
  profit: MoneySchema.nullable(),
  profitPercent: z.string().nullable(),
});
export type SaleVehicleFinancialIndicatorsResponseBodySaleVehiclePhoto = z.infer<
  typeof SaleVehicleFinancialIndicatorsResponseBodySchemaSaleVehiclePhoto
>;
export const SaleVehicleVehicleWarehouseResponseBodySchemaSaleVehiclePhoto = z.object({
  id: z.string(),
  name: z.string(),
});
export type SaleVehicleVehicleWarehouseResponseBodySaleVehiclePhoto = z.infer<
  typeof SaleVehicleVehicleWarehouseResponseBodySchemaSaleVehiclePhoto
>;
export const SaleVehiclePriceInForeignCurrencyResponseBodySchemaSaleVehiclePhoto = z.object({
  foreignCurrencyCode: z.string().nullable(),
  priceWithoutVat: z.string().nullable(),
  priceWithVat: z.string().nullable(),
});
export type SaleVehiclePriceInForeignCurrencyResponseBodySaleVehiclePhoto = z.infer<
  typeof SaleVehiclePriceInForeignCurrencyResponseBodySchemaSaleVehiclePhoto
>;
export const AuthorResponseBodySchemaSaleVehiclePhoto = z.object({
  userId: z.string(),
  fullName: z.string(),
});
export type AuthorResponseBodySaleVehiclePhoto = z.infer<
  typeof AuthorResponseBodySchemaSaleVehiclePhoto
>;
export const AdvanceDepositResponseBodySchemaSaleVehiclePhoto = z.object({
  id: z.string(),
  businessCaseId: z.string(),
  incomeCashReceiptId: z.string(),
  depositedAt: z.string(),
  expenseCashReceiptId: z.string().nullable(),
});
export type AdvanceDepositResponseBodySaleVehiclePhoto = z.infer<
  typeof AdvanceDepositResponseBodySchemaSaleVehiclePhoto
>;
export const ReservationResponseBodySchemaSaleVehiclePhoto = z.object({
  reservedUntil: z.string(),
  expired: z.boolean(),
  customer: z.string().nullable(),
  note: z.string().nullable(),
  createdAt: z.string(),
  createdBy: AuthorResponseBodySchemaSaleVehiclePhoto,
  paidAdvanceDeposit: AdvanceDepositResponseBodySchemaSaleVehiclePhoto.nullable(),
  refundedAdvanceDeposits: z.array(AdvanceDepositResponseBodySchemaSaleVehiclePhoto),
  customerId: z.string().nullable(),
  businessCaseId: z.string().nullable(),
  canceledAt: z.string(),
});
export type ReservationResponseBodySaleVehiclePhoto = z.infer<
  typeof ReservationResponseBodySchemaSaleVehiclePhoto
>;
export const SaleVehiclePriceResponseBodySchemaSaleVehiclePhoto = z.object({
  withoutVat: MoneySchema.nullable(),
  withVat: MoneySchema.nullable(),
  vatRate: z.string().nullable(),
});
export type SaleVehiclePriceResponseBodySaleVehiclePhoto = z.infer<
  typeof SaleVehiclePriceResponseBodySchemaSaleVehiclePhoto
>;
export const SaleVehicleResponseBodySchemaSaleVehiclePhoto = z.object({
  id: z.string(),
  vehicleId: z.string(),
  branchId: z.string(),
  type: z.enum(['IN_STOCK', 'BROKERAGE']),
  createdAt: z.string(),
  state: z.enum(['BUYING', 'FAILED', 'TO_SELL', 'RESERVED', 'SOLD']).nullable(),
  sellingPrice: SaleVehiclePriceResponseBodySchemaSaleVehiclePhoto,
  b2bSellingPrice: SaleVehiclePriceResponseBodySchemaSaleVehiclePhoto,
  realSellingPrice: SaleVehiclePriceResponseBodySchemaSaleVehiclePhoto,
  purchasePrice: SaleVehiclePriceResponseBodySchemaSaleVehiclePhoto,
  profitPrice: SaleVehiclePriceResponseBodySchemaSaleVehiclePhoto,
  profitPercent: BigDecimalSchema.nullable(),
  isVatDeductible: z.boolean().nullable(),
  vatCode: z.string().nullable(),
  purchasePriceVatCode: z.string(),
  salePriceVatCode: z.string(),
  b2bSalePriceVatCode: z.string(),
  currency: Alpha3Schema.nullable(),
  sellingState: z
    .enum([
      'not-set',
      'for-sale',
      'selling',
      'contract',
      'payment-pending',
      'sold',
      'handed-over',
      'not-for-sale',
      'not-sold',
      'cannot-be-sold',
    ])
    .nullable(),
  buyingState: z
    .enum([
      'not-set',
      'to-buy',
      'buying',
      'for-pricing',
      'priced',
      'contract',
      'bought',
      'not-bought',
      'returned-to-customer',
    ])
    .nullable(),
  isAvailable: z.boolean(),
  activeReservation: ReservationResponseBodySchemaSaleVehiclePhoto.nullable(),
  nonActiveReservations: z.array(ReservationResponseBodySchemaSaleVehiclePhoto),
  saleBusinessCaseId: z.string().nullable(),
  vehicleWarehouse: SaleVehicleVehicleWarehouseResponseBodySchemaSaleVehiclePhoto.nullable(),
  isPhotographed: z.boolean(),
  originalCarPrice: MoneySchema.nullable(),
  leasingAndCreditCompany: z.boolean(),
  leasingAndCreditCompanyCodeId: z.string().nullable(),
  endOfFinancing: z.string().nullable(),
  financingContractNumber: z.string().nullable(),
  financingNote: z.string().nullable(),
  isNotClosedBusinessCase: z.boolean(),
  closedSellingBusinessCaseDate: z.string().nullable(),
  isClosedPurchaseBusinessCase: z.boolean(),
  purchasePriceIsForeignCurrency:
    SaleVehiclePriceInForeignCurrencyResponseBodySchemaSaleVehiclePhoto.nullable(),
  sellingPriceIsForeignCurrency:
    SaleVehiclePriceInForeignCurrencyResponseBodySchemaSaleVehiclePhoto.nullable(),
  financialIndicators: SaleVehicleFinancialIndicatorsResponseBodySchemaSaleVehiclePhoto,
  stockInDate: z.string().nullable(),
  purchaseDate: z.string().nullable(),
  purchaseMileage: z.number().nullable(),
  saleMileage: z.number().nullable(),
  watermarkId: z.string().nullable(),
  soldAt: z.string().nullable(),
  salePresetId: z.string().nullable(),
});
export type SaleVehicleResponseBodySaleVehiclePhoto = z.infer<
  typeof SaleVehicleResponseBodySchemaSaleVehiclePhoto
>;
export const GetSaleVehicleApiResponseSchemaSaleVehiclePhoto =
  SaleVehicleResponseBodySchemaSaleVehiclePhoto;
export type GetSaleVehicleApiResponseSaleVehiclePhoto = z.infer<
  typeof GetSaleVehicleApiResponseSchemaSaleVehiclePhoto
>;
export const GetSaleVehicleApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
});
export type GetSaleVehicleApiArgSaleVehiclePhoto = z.infer<
  typeof GetSaleVehicleApiArgSchemaSaleVehiclePhoto
>;
export const UpdateSaleVehicleApiResponseSchemaSaleVehiclePhoto = z.unknown();
export type UpdateSaleVehicleApiResponseSaleVehiclePhoto = z.infer<
  typeof UpdateSaleVehicleApiResponseSchemaSaleVehiclePhoto
>;
export const UpdateSaleVehicleRequestBodySchemaSaleVehiclePhoto = z.object({
  sellingPrice: z.string().nullable(),
  sellingPriceWithVat: z.string().nullable(),
  sellingPriceVatRate: z.string().nullable(),
  purchasePrice: z.string().nullable(),
  purchasePriceWithVat: z.string().nullable(),
  purchasePriceVatRate: z.string().nullable(),
  currencyCode: z.string().nullable(),
  isVatDeductible: z.boolean().nullable(),
  vatCode: z.string().nullable(),
  updateReasonNote: z.string().nullable(),
  originalCarPrice: z.string().nullable(),
});
export type UpdateSaleVehicleRequestBodySaleVehiclePhoto = z.infer<
  typeof UpdateSaleVehicleRequestBodySchemaSaleVehiclePhoto
>;
export const UpdateSaleVehicleApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
  businessCaseId: z.string(),
  updateSaleVehicleRequestBody: UpdateSaleVehicleRequestBodySchemaSaleVehiclePhoto,
});
export type UpdateSaleVehicleApiArgSaleVehiclePhoto = z.infer<
  typeof UpdateSaleVehicleApiArgSchemaSaleVehiclePhoto
>;
export const SaleVehicleByVehicleResponseBodySchemaSaleVehiclePhoto = z.object({
  activeSaleVehicleId: z.string().nullable(),
  saleVehicleIds: z.array(z.string()),
});
export type SaleVehicleByVehicleResponseBodySaleVehiclePhoto = z.infer<
  typeof SaleVehicleByVehicleResponseBodySchemaSaleVehiclePhoto
>;

export const GetSaleVehicleByVehicleApiResponseSchemaSaleVehiclePhoto =
  SaleVehicleByVehicleResponseBodySchemaSaleVehiclePhoto;
export type GetSaleVehicleByVehicleApiResponseSaleVehiclePhoto = z.infer<
  typeof GetSaleVehicleByVehicleApiResponseSchemaSaleVehiclePhoto
>;
export const GetSaleVehicleByVehicleApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
  type: z.enum(['IN_STOCK', 'BROKERAGE']).optional(),
});
export type GetSaleVehicleByVehicleApiArgSaleVehiclePhoto = z.infer<
  typeof GetSaleVehicleByVehicleApiArgSchemaSaleVehiclePhoto
>;
export const MakeSaleVehicleAvailableForSaleApiResponseSchemaSaleVehiclePhoto = z.unknown();
export type MakeSaleVehicleAvailableForSaleApiResponseSaleVehiclePhoto = z.infer<
  typeof MakeSaleVehicleAvailableForSaleApiResponseSchemaSaleVehiclePhoto
>;
export const MakeSaleVehicleAvailableForSaleApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
});
export type MakeSaleVehicleAvailableForSaleApiArgSaleVehiclePhoto = z.infer<
  typeof MakeSaleVehicleAvailableForSaleApiArgSchemaSaleVehiclePhoto
>;
export const MakeSaleVehicleIsNotForSaleApiResponseSchemaSaleVehiclePhoto = z.unknown();
export type MakeSaleVehicleIsNotForSaleApiResponseSaleVehiclePhoto = z.infer<
  typeof MakeSaleVehicleIsNotForSaleApiResponseSchemaSaleVehiclePhoto
>;
export const MakeSaleVehicleIsNotForSaleApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
});
export type MakeSaleVehicleIsNotForSaleApiArgSaleVehiclePhoto = z.infer<
  typeof MakeSaleVehicleIsNotForSaleApiArgSchemaSaleVehiclePhoto
>;
export const MakeSaleVehicleIsNotSoldApiResponseSchemaSaleVehiclePhoto = z.unknown();
export type MakeSaleVehicleIsNotSoldApiResponseSaleVehiclePhoto = z.infer<
  typeof MakeSaleVehicleIsNotSoldApiResponseSchemaSaleVehiclePhoto
>;
export const MakeSaleVehicleIsNotSoldApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
});
export type MakeSaleVehicleIsNotSoldApiArgSaleVehiclePhoto = z.infer<
  typeof MakeSaleVehicleIsNotSoldApiArgSchemaSaleVehiclePhoto
>;
export const MakeSaleVehicleIsReturnedToCustomerApiResponseSchemaSaleVehiclePhoto = z.unknown();
export type MakeSaleVehicleIsReturnedToCustomerApiResponseSaleVehiclePhoto = z.infer<
  typeof MakeSaleVehicleIsReturnedToCustomerApiResponseSchemaSaleVehiclePhoto
>;
export const MakeSaleVehicleIsReturnedToCustomerApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
});
export type MakeSaleVehicleIsReturnedToCustomerApiArgSaleVehiclePhoto = z.infer<
  typeof MakeSaleVehicleIsReturnedToCustomerApiArgSchemaSaleVehiclePhoto
>;
export const ReRegisterVehicleForSaleApiResponseSchemaSaleVehiclePhoto = z.unknown();
export type ReRegisterVehicleForSaleApiResponseSaleVehiclePhoto = z.infer<
  typeof ReRegisterVehicleForSaleApiResponseSchemaSaleVehiclePhoto
>;
export const ReRegisterVehicleForSaleApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
});
export type ReRegisterVehicleForSaleApiArgSaleVehiclePhoto = z.infer<
  typeof ReRegisterVehicleForSaleApiArgSchemaSaleVehiclePhoto
>;
export const ApplyCostPresetRequestBodySchemaSaleVehiclePhoto = z.object({
  costPresetIds: z.array(z.string()),
  businessCaseId: z.string().nullish(),
});
export type ApplyCostPresetRequestBodySaleVehiclePhoto = z.infer<
  typeof ApplyCostPresetRequestBodySchemaSaleVehiclePhoto
>;
export const CreateCostPresetRequestBodySchemaSaleVehiclePhoto = z.object({
  name: z.string(),
});
export type CreateCostPresetRequestBodySaleVehiclePhoto = z.infer<
  typeof CreateCostPresetRequestBodySchemaSaleVehiclePhoto
>;
export const CostPresetResponseBodySchemaSaleVehiclePhoto = z.object({
  id: z.string(),
  name: z.string(),
});
export type CostPresetResponseBodySaleVehiclePhoto = z.infer<
  typeof CostPresetResponseBodySchemaSaleVehiclePhoto
>;
export const ApplyCostPresetApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
  body: ApplyCostPresetRequestBodySchemaSaleVehiclePhoto,
});
export type ApplyCostPresetApiArgSaleVehiclePhoto = z.infer<
  typeof ApplyCostPresetApiArgSchemaSaleVehiclePhoto
>;
export const CreateCostPresetApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
  body: CreateCostPresetRequestBodySchemaSaleVehiclePhoto,
});
export type CreateCostPresetApiArgSaleVehiclePhoto = z.infer<
  typeof CreateCostPresetApiArgSchemaSaleVehiclePhoto
>;
export const DeleteCostPresetApiArgSchemaSaleVehiclePhoto = z.object({
  costPresetId: z.string(),
});
export type DeleteCostPresetApiArgSaleVehiclePhoto = z.infer<
  typeof DeleteCostPresetApiArgSchemaSaleVehiclePhoto
>;
export const GetCostPresetListApiResponseSchemaSaleVehiclePhoto = z.array(
  CostPresetResponseBodySchemaSaleVehiclePhoto
);
export type GetCostPresetListApiResponseSaleVehiclePhoto = z.infer<
  typeof GetCostPresetListApiResponseSchemaSaleVehiclePhoto
>;
export const CostPresetBodySchemaSaleVehiclePhoto = z.object({
  value: z.string(),
  label: z.string(),
});
export type CostPresetBodySaleVehiclePhoto = z.infer<typeof CostPresetBodySchemaSaleVehiclePhoto>;
export const GetCostPresetListResultSchemaSaleVehiclePhoto = z.array(
  CostPresetBodySchemaSaleVehiclePhoto
);
export type GetCostPresetListResultSaleVehiclePhoto = z.infer<
  typeof GetCostPresetListResultSchemaSaleVehiclePhoto
>;
export const ApplyEarningPresetRequestBodySchemaSaleVehiclePhoto = z.object({
  earningPresetIds: z.array(z.string()),
  businessCaseId: z.string().nullable().optional(),
});
export type ApplyEarningPresetRequestBodySaleVehiclePhoto = z.infer<
  typeof ApplyEarningPresetRequestBodySchemaSaleVehiclePhoto
>;
export const CreateEarningPresetRequestBodySchemaSaleVehiclePhoto = z.object({
  name: z.string(),
});
export type CreateEarningPresetRequestBodySaleVehiclePhoto = z.infer<
  typeof CreateEarningPresetRequestBodySchemaSaleVehiclePhoto
>;
export const EarningPresetResponseBodySchemaSaleVehiclePhoto = z.object({
  id: z.string(),
  name: z.string(),
});
export type EarningPresetResponseBodySaleVehiclePhoto = z.infer<
  typeof EarningPresetResponseBodySchemaSaleVehiclePhoto
>;
export const ApplyEarningPresetApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
  body: ApplyEarningPresetRequestBodySchemaSaleVehiclePhoto,
});
export type ApplyEarningPresetApiArgSaleVehiclePhoto = z.infer<
  typeof ApplyEarningPresetApiArgSchemaSaleVehiclePhoto
>;
export const CreateEarningPresetApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
  body: CreateEarningPresetRequestBodySchemaSaleVehiclePhoto,
});
export type CreateEarningPresetApiArgSaleVehiclePhoto = z.infer<
  typeof CreateEarningPresetApiArgSchemaSaleVehiclePhoto
>;
export const DeleteEarningPresetApiArgSchemaSaleVehiclePhoto = z.object({
  earningPresetId: z.string(),
});
export type DeleteEarningPresetApiArgSaleVehiclePhoto = z.infer<
  typeof DeleteEarningPresetApiArgSchemaSaleVehiclePhoto
>;
export const GetEarningPresetListApiResponseSchemaSaleVehiclePhoto = z.array(
  EarningPresetResponseBodySchemaSaleVehiclePhoto
);
export type GetEarningPresetListApiResponseSaleVehiclePhoto = z.infer<
  typeof GetEarningPresetListApiResponseSchemaSaleVehiclePhoto
>;
export const GetEarningPresetListResultSchemaSaleVehiclePhoto = z.array(
  CostPresetBodySchemaSaleVehiclePhoto
);
export type GetEarningPresetListResultSaleVehiclePhoto = z.infer<
  typeof GetEarningPresetListResultSchemaSaleVehiclePhoto
>;
export const SaleVehicleSellingStateSchemaSaleVehiclePhoto = z
  .enum([
    'not-set',
    'for-sale',
    'selling',
    'not-for-sale',
    'sold',
    'not-sold',
    'contract',
    'payment-pending',
    'handed-over',
    'cannot-be-sold',
  ])
  .nullable();
export type SaleVehicleSellingStateSaleVehiclePhoto = z.infer<
  typeof SaleVehicleSellingStateSchemaSaleVehiclePhoto
>;
export const SaleVehicleBuyingStateSchemaSaleVehiclePhoto = z
  .enum([
    'not-set',
    'buying',
    'for-pricing',
    'priced',
    'not-bought',
    'bought',
    'returned-to-customer',
    'to-buy',
    'contract',
  ])
  .nullable();
export type SaleVehicleBuyingStateSaleVehiclePhoto = z.infer<
  typeof SaleVehicleBuyingStateSchemaSaleVehiclePhoto
>;
export const ReserveSaleVehicleApiResponseSchemaSaleVehiclePhoto = z.unknown();
export type ReserveSaleVehicleApiResponseSaleVehiclePhoto = z.infer<
  typeof ReserveSaleVehicleApiResponseSchemaSaleVehiclePhoto
>;
export const ReserveSaleVehicleRequestBodySchemaSaleVehiclePhoto = z.object({
  reserveUntil: z.string(),
  customer: z.string().nullable(),
  note: z.string().nullable(),
  customerId: z.string().nullable().optional(),
  businessCaseId: z.string().nullable().optional(),
});
export type ReserveSaleVehicleRequestBodySaleVehiclePhoto = z.infer<
  typeof ReserveSaleVehicleRequestBodySchemaSaleVehiclePhoto
>;
export const ReserveSaleVehicleApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
  body: ReserveSaleVehicleRequestBodySchemaSaleVehiclePhoto,
});
export type ReserveSaleVehicleApiArgSaleVehiclePhoto = z.infer<
  typeof ReserveSaleVehicleApiArgSchemaSaleVehiclePhoto
>;
export const UpdateSaleVehicleReservationRequestBodySchemaSaleVehiclePhoto = z.object({
  reserveUntil: z.string(),
  customer: z.string().nullable(),
  note: z.string().nullable(),
  customerId: z.string().nullable().optional(),
  businessCaseId: z.string().nullable().optional(),
});
export type UpdateSaleVehicleReservationRequestBodySaleVehiclePhoto = z.infer<
  typeof UpdateSaleVehicleReservationRequestBodySchemaSaleVehiclePhoto
>;
export const CancelSaleVehicleReservationApiResponseSchemaSaleVehiclePhoto = z.unknown();
export type CancelSaleVehicleReservationApiResponseSaleVehiclePhoto = z.infer<
  typeof CancelSaleVehicleReservationApiResponseSchemaSaleVehiclePhoto
>;
export const CancelSaleVehicleReservationApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
});
export type CancelSaleVehicleReservationApiArgSaleVehiclePhoto = z.infer<
  typeof CancelSaleVehicleReservationApiArgSchemaSaleVehiclePhoto
>;
export const UpdateSaleVehicleReservationApiResponseSchemaSaleVehiclePhoto = z.unknown();
export type UpdateSaleVehicleReservationApiResponseSaleVehiclePhoto = z.infer<
  typeof UpdateSaleVehicleReservationApiResponseSchemaSaleVehiclePhoto
>;
export const UpdateSaleVehicleReservationApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
  body: UpdateSaleVehicleReservationRequestBodySchemaSaleVehiclePhoto,
});
export type UpdateSaleVehicleReservationApiArgSaleVehiclePhoto = z.infer<
  typeof UpdateSaleVehicleReservationApiArgSchemaSaleVehiclePhoto
>;
export const ReserveSaleVehicleWithAdvanceDepositRequestBodySchemaSaleVehiclePhoto = z.object({
  reserveUntil: z.string(),
  reservationNote: z.string().nullable(),
  cashReceiptNote: z.string().nullable(),
  businessCaseId: z.string(),
  customerId: z.string(),
  cashRegisterId: z.string(),
  issuedAt: z.string(),
  amount: MoneySchema,
});
export type ReserveSaleVehicleWithAdvanceDepositRequestBodySaleVehiclePhoto = z.infer<
  typeof ReserveSaleVehicleWithAdvanceDepositRequestBodySchemaSaleVehiclePhoto
>;
export const ReserveSaleVehicleWithAdvanceDepositApiResponseSchemaSaleVehiclePhoto = z.unknown();
export type ReserveSaleVehicleWithAdvanceDepositApiResponseSaleVehiclePhoto = z.infer<
  typeof ReserveSaleVehicleWithAdvanceDepositApiResponseSchemaSaleVehiclePhoto
>;
export const ReserveSaleVehicleWithAdvanceDepositApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
  body: ReserveSaleVehicleWithAdvanceDepositRequestBodySchemaSaleVehiclePhoto,
});
export type ReserveSaleVehicleWithAdvanceDepositApiArgSaleVehiclePhoto = z.infer<
  typeof ReserveSaleVehicleWithAdvanceDepositApiArgSchemaSaleVehiclePhoto
>;
export const RefundAdvanceDepositInSaleVehicleActiveReservationRequestBodySchemaSaleVehiclePhoto =
  z.object({
    issuedAt: z.string(),
  });
export type RefundAdvanceDepositInSaleVehicleActiveReservationRequestBodySaleVehiclePhoto = z.infer<
  typeof RefundAdvanceDepositInSaleVehicleActiveReservationRequestBodySchemaSaleVehiclePhoto
>;
export const RefundAdvanceDepositInSaleVehicleActiveReservationApiResponseSchemaSaleVehiclePhoto =
  z.unknown();
export type RefundAdvanceDepositInSaleVehicleActiveReservationApiResponseSaleVehiclePhoto = z.infer<
  typeof RefundAdvanceDepositInSaleVehicleActiveReservationApiResponseSchemaSaleVehiclePhoto
>;
export const RefundAdvanceDepositInSaleVehicleActiveReservationApiArgSchemaSaleVehiclePhoto =
  z.object({
    vehicleId: z.string(),
    refundAdvanceDepositInSaleVehicleActiveReservationRequestBody:
      RefundAdvanceDepositInSaleVehicleActiveReservationRequestBodySchemaSaleVehiclePhoto,
  });
export type RefundAdvanceDepositInSaleVehicleActiveReservationApiArgSaleVehiclePhoto = z.infer<
  typeof RefundAdvanceDepositInSaleVehicleActiveReservationApiArgSchemaSaleVehiclePhoto
>;
export const CancelAdvanceDepositInSaleVehicleActiveReservationApiResponseSchemaSaleVehiclePhoto =
  z.unknown();
export type CancelAdvanceDepositInSaleVehicleActiveReservationApiResponseSaleVehiclePhoto = z.infer<
  typeof CancelAdvanceDepositInSaleVehicleActiveReservationApiResponseSchemaSaleVehiclePhoto
>;
export const CancelAdvanceDepositInSaleVehicleActiveReservationApiArgSchemaSaleVehiclePhoto =
  z.object({
    vehicleId: z.string(),
  });
export type CancelAdvanceDepositInSaleVehicleActiveReservationApiArgSaleVehiclePhoto = z.infer<
  typeof CancelAdvanceDepositInSaleVehicleActiveReservationApiArgSchemaSaleVehiclePhoto
>;
export const AddAdvanceDepositToSaleVehicleActiveReservationRequestBodySchemaSaleVehiclePhoto =
  z.object({
    note: z.string().nullable(),
    businessCaseId: z.string(),
    customerId: z.string(),
    cashRegisterId: z.string(),
    issuedAt: z.string(),
    amount: MoneySchema,
  });
export type AddAdvanceDepositToSaleVehicleActiveReservationRequestBodySaleVehiclePhoto = z.infer<
  typeof AddAdvanceDepositToSaleVehicleActiveReservationRequestBodySchemaSaleVehiclePhoto
>;
export const AddAdvanceDepositToSaleVehicleActiveReservationApiResponseSchemaSaleVehiclePhoto =
  z.unknown();
export type AddAdvanceDepositToSaleVehicleActiveReservationApiResponseSaleVehiclePhoto = z.infer<
  typeof AddAdvanceDepositToSaleVehicleActiveReservationApiResponseSchemaSaleVehiclePhoto
>;
export const AddAdvanceDepositToSaleVehicleActiveReservationApiArgSchemaSaleVehiclePhoto = z.object(
  {
    vehicleId: z.string(),
    body: AddAdvanceDepositToSaleVehicleActiveReservationRequestBodySchemaSaleVehiclePhoto,
  }
);
export type AddAdvanceDepositToSaleVehicleActiveReservationApiArgSaleVehiclePhoto = z.infer<
  typeof AddAdvanceDepositToSaleVehicleActiveReservationApiArgSchemaSaleVehiclePhoto
>;
export const DeleteLeasingAndCreditCompanyApiResponseSchemaSaleVehiclePhoto = z.unknown();
export type DeleteLeasingAndCreditCompanyApiResponseSaleVehiclePhoto = z.infer<
  typeof DeleteLeasingAndCreditCompanyApiResponseSchemaSaleVehiclePhoto
>;
export const DeleteLeasingAndCreditCompanyApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
});
export type DeleteLeasingAndCreditCompanyApiArgSaleVehiclePhoto = z.infer<
  typeof DeleteLeasingAndCreditCompanyApiArgSchemaSaleVehiclePhoto
>;
export const EnableLeasingAndCreditCompanyApiResponseSchemaSaleVehiclePhoto = z.object({});
export type EnableLeasingAndCreditCompanyApiResponseSaleVehiclePhoto = z.infer<
  typeof EnableLeasingAndCreditCompanyApiResponseSchemaSaleVehiclePhoto
>;
export const EnableLeasingAndCreditCompanyApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
});
export type EnableLeasingAndCreditCompanyApiArgSaleVehiclePhoto = z.infer<
  typeof EnableLeasingAndCreditCompanyApiArgSchemaSaleVehiclePhoto
>;
export const LeasingAndCreditCompanyApiResponseSchemaSaleVehiclePhoto = z.object({});
export type LeasingAndCreditCompanyApiResponseSaleVehiclePhoto = z.infer<
  typeof LeasingAndCreditCompanyApiResponseSchemaSaleVehiclePhoto
>;
export const LeasingAndCreditCompanyRequestBodySchemaSaleVehiclePhoto = z.object({
  endOfFinancing: z.string().nullable(),
  financingContractNumber: z.string().nullable(),
  note: z.string().nullable(),
});
export type LeasingAndCreditCompanyRequestBodySaleVehiclePhoto = z.infer<
  typeof LeasingAndCreditCompanyRequestBodySchemaSaleVehiclePhoto
>;
export const LeasingAndCreditCompanyApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
  codeId: z.string(),
  body: LeasingAndCreditCompanyRequestBodySchemaSaleVehiclePhoto,
});
export type LeasingAndCreditCompanyApiArgSaleVehiclePhoto = z.infer<
  typeof LeasingAndCreditCompanyApiArgSchemaSaleVehiclePhoto
>;
export const GetVehicleSalesActionsApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
});
export type GetVehicleSalesActionsApiArgSaleVehiclePhoto = z.infer<
  typeof GetVehicleSalesActionsApiArgSchemaSaleVehiclePhoto
>;
export const VehicleSalesActionSchemaSaleVehiclePhoto = z.enum([
  'SALE_VEHICLE_TEMPORARY_REMOVE_FROM_SALE',
  'SALE_VEHICLE_REMOVE_FROM_SALE',
  'SALE_VEHICLE_SELL',
  'SALE_VEHICLE_PUT_BACK_UP_FOR_SALE',
  'SALE_VEHICLE_RE_REGISTER_FOR_SALE',
  'SALE_VEHICLE_BUY',
  'SALE_VEHICLE_RESERVE',
  'SALE_VEHICLE_UPDATE',
  'SALE_VEHICLE_ADD_EXPECTED_COST',
  'SALE_VEHICLE_EDIT_EXPECTED_COST',
  'SALE_VEHICLE_REMOVE_EXPECTED_COST',
]);
export type VehicleSalesActionSaleVehiclePhoto = z.infer<
  typeof VehicleSalesActionSchemaSaleVehiclePhoto
>;
export const VehicleSalesActionsResponseBodySchemaSaleVehiclePhoto = z.object({
  actions: z.array(VehicleSalesActionSchemaSaleVehiclePhoto),
});
export type VehicleSalesActionsResponseBodySaleVehiclePhoto = z.infer<
  typeof VehicleSalesActionsResponseBodySchemaSaleVehiclePhoto
>;
export const GetVehicleSalesActionsApiResponseSchemaSaleVehiclePhoto =
  VehicleSalesActionsResponseBodySchemaSaleVehiclePhoto;
export type GetVehicleSalesActionsApiResponseSaleVehiclePhoto = z.infer<
  typeof GetVehicleSalesActionsApiResponseSchemaSaleVehiclePhoto
>;
export const PatchVehiclePricesApiResponseSchemaSaleVehiclePhoto = z.unknown();
export type PatchVehiclePricesApiResponseSaleVehiclePhoto = z.infer<
  typeof PatchVehiclePricesApiResponseSchemaSaleVehiclePhoto
>;
export const PriceWithVatRequestBodySchemaSaleVehiclePhoto = z.object({
  vatCode: z.string(),
  withoutVat: z.string().nullable(),
  withVat: z.string().nullable(),
  vatRate: z.string().nullable(),
});
export type PriceWithVatRequestBodySaleVehiclePhoto = z.infer<
  typeof PriceWithVatRequestBodySchemaSaleVehiclePhoto
>;
export const PriceInForeignCurrencyRequestBodySchemaSaleVehiclePhoto = z.object({
  foreignCurrencyCode: z.string(),
  priceWithoutVat: z.string().nullable(),
  priceWithVat: z.string().nullable(),
});

export type PriceInForeignCurrencyRequestBodySaleVehiclePhoto = z.infer<
  typeof PriceInForeignCurrencyRequestBodySchemaSaleVehiclePhoto
>;
export const PatchVehiclePricesRequestBodySchemaSaleVehiclePhoto = z.object({
  isVatDeductible: z.boolean().nullish(),
  purchasePrice: PriceWithVatRequestBodySchemaSaleVehiclePhoto.nullish(),
  sellingPrice: PriceWithVatRequestBodySchemaSaleVehiclePhoto.nullish(),
  b2bSellingPrice: PriceWithVatRequestBodySchemaSaleVehiclePhoto.nullish(),
  purchasePriceInForeignCurrency: PriceInForeignCurrencyRequestBodySchemaSaleVehiclePhoto.nullish(),
  sellingPriceInForeignCurrency: PriceInForeignCurrencyRequestBodySchemaSaleVehiclePhoto.nullish(),
  originalCarPrice: z.string().nullish(),
  updateReasonNote: z.string().nullish(),
});

export type PatchVehiclePricesRequestBodySaleVehiclePhoto = z.infer<
  typeof PatchVehiclePricesRequestBodySchemaSaleVehiclePhoto
>;
export const PatchVehiclePricesApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
  patchVehiclePricesRequestBody: PatchVehiclePricesRequestBodySchemaSaleVehiclePhoto,
});
export type PatchVehiclePricesApiArgSaleVehiclePhoto = z.infer<
  typeof PatchVehiclePricesApiArgSchemaSaleVehiclePhoto
>;
export const CancelVehicleReservationApiResponseSchemaSaleVehiclePhoto = z.unknown();
export type CancelVehicleReservationApiResponseSaleVehiclePhoto = z.infer<
  typeof CancelVehicleReservationApiResponseSchemaSaleVehiclePhoto
>;
export const CancelVehicleReservationApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
});
export type CancelVehicleReservationApiArgSaleVehiclePhoto = z.infer<
  typeof CancelVehicleReservationApiArgSchemaSaleVehiclePhoto
>;
export const UpdateVehicleReservationRequestBodySchemaSaleVehiclePhoto = z.object({
  reserveUntil: z.string(),
  customer: z.string().nullable(),
  note: z.string().nullable(),
  customerId: z.string().nullish(),
  businessCaseId: z.string().nullish(),
});

export type UpdateVehicleReservationRequestBodySaleVehiclePhoto = z.infer<
  typeof UpdateVehicleReservationRequestBodySchemaSaleVehiclePhoto
>;
export const UpdateVehicleReservationApiResponseSchemaSaleVehiclePhoto = z.unknown();
export type UpdateVehicleReservationApiResponseSaleVehiclePhoto = z.infer<
  typeof UpdateVehicleReservationApiResponseSchemaSaleVehiclePhoto
>;
export const UpdateVehicleReservationApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
  body: UpdateVehicleReservationRequestBodySchemaSaleVehiclePhoto,
});
export type UpdateVehicleReservationApiArgSaleVehiclePhoto = z.infer<
  typeof UpdateVehicleReservationApiArgSchemaSaleVehiclePhoto
>;
export const VehicleActiveReservationApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
});
export type VehicleActiveReservationApiArgSaleVehiclePhoto = z.infer<
  typeof VehicleActiveReservationApiArgSchemaSaleVehiclePhoto
>;
export type VehicleReservationResponseBodySaleVehiclePhoto = z.infer<
  typeof VehicleReservationResponseBodySchemaSaleVehiclePhoto
>;
export const VehicleReservationCustomerResponseBodySchemaSaleVehiclePhoto = z.object({
  id: z.string(),
  name: z.string(),
});

export type VehicleReservationCustomerResponseBodySaleVehiclePhoto = z.infer<
  typeof VehicleReservationCustomerResponseBodySchemaSaleVehiclePhoto
>;
export const VehicleReservationBusinessCaseResponseBodySchemaSaleVehiclePhoto = z.object({
  id: z.string(),
  code: z.string(),
});
export type VehicleReservationBusinessCaseResponseBodySaleVehiclePhoto = z.infer<
  typeof VehicleReservationBusinessCaseResponseBodySchemaSaleVehiclePhoto
>;
export const VehicleReservationDepositResponseBodySchemaSaleVehiclePhoto = z.object({
  incomeCashReceiptId: z.string(),
  expenseCashReceiptId: z.string().nullable(),
});
export type VehicleReservationDepositResponseBodySaleVehiclePhoto = z.infer<
  typeof VehicleReservationDepositResponseBodySchemaSaleVehiclePhoto
>;
export const VehicleReservationUserResponseBodySchemaSaleVehiclePhoto = z.object({
  id: z.string(),
  fullName: z.string(),
});
export type VehicleReservationUserResponseBodySaleVehiclePhoto = z.infer<
  typeof VehicleReservationUserResponseBodySchemaSaleVehiclePhoto
>;
export const VehicleReservationResponseBodySchemaSaleVehiclePhoto = z.object({
  reservedUntil: z.string(),
  isExpired: z.boolean(),
  note: z.string().nullable(),
  customer: VehicleReservationCustomerResponseBodySchemaSaleVehiclePhoto.nullable(),
  businessCase: VehicleReservationBusinessCaseResponseBodySchemaSaleVehiclePhoto.nullable(),
  paidDeposit: VehicleReservationDepositResponseBodySchemaSaleVehiclePhoto.nullable(),
  refundedDeposits: VehicleReservationDepositResponseBodySchemaSaleVehiclePhoto.array(),
  createdAt: z.string(),
  createdBy: VehicleReservationUserResponseBodySchemaSaleVehiclePhoto,
  canceledAt: z.string().nullable(),
  canceledBy: VehicleReservationUserResponseBodySchemaSaleVehiclePhoto.nullable(),
});
export const VehicleActiveReservationApiResponseSchemaSaleVehiclePhoto =
  VehicleReservationResponseBodySchemaSaleVehiclePhoto;
export type VehicleActiveReservationApiResponseSaleVehiclePhoto = z.infer<
  typeof VehicleActiveReservationApiResponseSchemaSaleVehiclePhoto
>;
export const AddVehicleReservationDepositApiResponseSchemaSaleVehiclePhoto = z.unknown();
export type AddVehicleReservationDepositApiResponseSaleVehiclePhoto = z.infer<
  typeof AddVehicleReservationDepositApiResponseSchemaSaleVehiclePhoto
>;
export const AddVehicleReservationDepositRequestBodySchemaSaleVehiclePhoto = z.object({
  note: z.string().nullable(),
  businessCaseId: z.string(),
  customerId: z.string(),
  cashRegisterId: z.string(),
  issuedAt: z.string(),
  amount: MoneySchema,
});
export type AddVehicleReservationDepositRequestBodySaleVehiclePhoto = z.infer<
  typeof AddVehicleReservationDepositRequestBodySchemaSaleVehiclePhoto
>;
export const AddVehicleReservationDepositApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
  'X-Branch': z.string(),
  body: AddVehicleReservationDepositRequestBodySchemaSaleVehiclePhoto,
});
export type AddVehicleReservationDepositApiArgSaleVehiclePhoto = z.infer<
  typeof AddVehicleReservationDepositApiArgSchemaSaleVehiclePhoto
>;

export const CancelVehicleReservationDepositApiResponseSchemaSaleVehiclePhoto = z.unknown();

export type CancelVehicleReservationDepositApiResponseSaleVehiclePhoto = z.infer<
  typeof CancelVehicleReservationDepositApiResponseSchemaSaleVehiclePhoto
>;
export const CancelVehicleReservationDepositApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
});
export type CancelVehicleReservationDepositApiArgSaleVehiclePhoto = z.infer<
  typeof CancelVehicleReservationDepositApiArgSchemaSaleVehiclePhoto
>;
export const VehicleReservationHistoryApiResponseSchemaSaleVehiclePhoto = z.array(
  VehicleReservationResponseBodySchemaSaleVehiclePhoto
);
export type VehicleReservationHistoryApiResponseSaleVehiclePhoto = z.infer<
  typeof VehicleReservationHistoryApiResponseSchemaSaleVehiclePhoto
>;
export const VehicleReservationHistoryApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
  saleVehicleId: z.string().nullish(),
  businessCaseId: z.string().nullish(),
});
export type VehicleReservationHistoryApiArgSaleVehiclePhoto = z.infer<
  typeof VehicleReservationHistoryApiArgSchemaSaleVehiclePhoto
>;
export const RefundVehicleReservationDepositApiResponseSchemaSaleVehiclePhoto = z.unknown();
export type RefundVehicleReservationDepositApiResponseSaleVehiclePhoto = z.infer<
  typeof RefundVehicleReservationDepositApiResponseSchemaSaleVehiclePhoto
>;
export const RefundVehicleReservationDepositRequestBodySchemaSaleVehiclePhoto = z.object({
  issuedAt: z.string(),
});
export type RefundVehicleReservationDepositRequestBodySaleVehiclePhoto = z.infer<
  typeof RefundVehicleReservationDepositRequestBodySchemaSaleVehiclePhoto
>;
export const RefundVehicleReservationDepositApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
  'X-Branch': z.string(),
  body: RefundVehicleReservationDepositRequestBodySchemaSaleVehiclePhoto,
});
export type RefundVehicleReservationDepositApiArgSaleVehiclePhoto = z.infer<
  typeof RefundVehicleReservationDepositApiArgSchemaSaleVehiclePhoto
>;
export const ReserveVehicleApiResponseSchemaSaleVehiclePhoto = z.unknown();

export type ReserveVehicleApiResponseSaleVehiclePhoto = z.infer<
  typeof ReserveVehicleApiResponseSchemaSaleVehiclePhoto
>;
export const ReserveVehicleRequestBodySchemaSaleVehiclePhoto = z.object({
  reserveUntil: z.string(),
  note: z.string().nullable(),
  customerId: z.string().nullish(),
  businessCaseId: z.string().nullish(),
});
export type ReserveVehicleRequestBodySaleVehiclePhoto = z.infer<
  typeof ReserveVehicleRequestBodySchemaSaleVehiclePhoto
>;
export const ReserveVehicleApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
  body: ReserveVehicleRequestBodySchemaSaleVehiclePhoto,
});
export type ReserveVehicleApiArgSaleVehiclePhoto = z.infer<
  typeof ReserveVehicleApiArgSchemaSaleVehiclePhoto
>;
export const GetActiveSaleVehicleApiResponseSchemaSaleVehiclePhoto =
  SaleVehicleResponseBodySchemaSaleVehiclePhoto;
export type GetActiveSaleVehicleApiResponseSaleVehiclePhoto = z.infer<
  typeof GetActiveSaleVehicleApiResponseSchemaSaleVehiclePhoto
>;
export const GetActiveSaleVehicleApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
});
export type GetActiveSaleVehicleApiArgSaleVehiclePhoto = z.infer<
  typeof GetActiveSaleVehicleApiArgSchemaSaleVehiclePhoto
>;
export const SaleVehicleAlbumResponseBodySchemaSaleVehiclePhoto = z.object({
  translation: z.string(),
  id: z.string(),
  name: z.string(),
  createdAt: z.string(),
});
export type SaleVehicleAlbumResponseBodySaleVehiclePhoto = z.infer<
  typeof SaleVehicleAlbumResponseBodySchemaSaleVehiclePhoto
>;
export const ListSaleVehicleAlbumsApiResponseSchemaSaleVehiclePhoto = z.array(
  SaleVehicleAlbumResponseBodySchemaSaleVehiclePhoto
);
export type ListSaleVehicleAlbumsApiResponseSaleVehiclePhoto = z.infer<
  typeof ListSaleVehicleAlbumsApiResponseSchemaSaleVehiclePhoto
>;
export const ListSaleVehicleAlbumsApiArgSchemaSaleVehiclePhoto = z.object({
  saleVehicleId: z.string().optional(),
});
export type ListSaleVehicleAlbumsApiArgSaleVehiclePhoto = z.infer<
  typeof ListSaleVehicleAlbumsApiArgSchemaSaleVehiclePhoto
>;
export const CreateSaleVehicleAlbumResponseBodySchemaSaleVehiclePhoto = z.object({
  saleVehicleAlbumId: z.string(),
});
export type CreateSaleVehicleAlbumResponseBodySaleVehiclePhoto = z.infer<
  typeof CreateSaleVehicleAlbumResponseBodySchemaSaleVehiclePhoto
>;
export const CreateSaleVehicleAlbumApiResponseSchemaSaleVehiclePhoto =
  CreateSaleVehicleAlbumResponseBodySchemaSaleVehiclePhoto;
export type CreateSaleVehicleAlbumApiResponseSaleVehiclePhoto = z.infer<
  typeof CreateSaleVehicleAlbumApiResponseSchemaSaleVehiclePhoto
>;
export const CreateSaleVehicleAlbumRequestBodySchemaSaleVehiclePhoto = z.object({
  saleVehicleId: z.string(),
  name: z.enum([
    'PHOTOS_CAR_ORIGINAL',
    'PHOTOS_CAR_PURCHASE',
    'PHOTOS_CAR_SALES',
    'PHOTOS_SERVICE_CASE',
    'PHOTOS_CUSTOM',
  ]),
  description: z.string().nullish(),
});
export type CreateSaleVehicleAlbumRequestBodySaleVehiclePhoto = z.infer<
  typeof CreateSaleVehicleAlbumRequestBodySchemaSaleVehiclePhoto
>;
export const CreateSaleVehicleAlbumApiArgSchemaSaleVehiclePhoto = z.object({
  createSaleVehicleAlbumRequestBody: CreateSaleVehicleAlbumRequestBodySchemaSaleVehiclePhoto,
});

export type CreateSaleVehicleAlbumApiArgSaleVehiclePhoto = z.infer<
  typeof CreateSaleVehicleAlbumApiArgSchemaSaleVehiclePhoto
>;
export const SaleVehiclePhotoResponseBodySchemaSaleVehiclePhoto = z.object({
  id: z.string(),
  fileId: z.string(),
  albumId: z.string(),
  weight: z.number(),
  isCoverPhoto: z.boolean(),
  url: z.string(),
  category: VehiclePhotoCategorySchema.nullable(),
});
export type SaleVehiclePhotoResponseBodySaleVehiclePhoto = z.infer<
  typeof SaleVehiclePhotoResponseBodySchemaSaleVehiclePhoto
>;
export const AddFilesToSaleVehicleAlbumRequestBodySchemaSaleVehiclePhoto = z.object({
  fileIds: z.array(z.string()),
});
export type AddFilesToSaleVehicleAlbumRequestBodySaleVehiclePhoto = z.infer<
  typeof AddFilesToSaleVehicleAlbumRequestBodySchemaSaleVehiclePhoto
>;
export const AddFilesToSaleVehicleAlbumResponseBodySchemaSaleVehiclePhoto = z.object({
  photos: z.array(SaleVehiclePhotoResponseBodySchemaSaleVehiclePhoto),
});
export type AddFilesToSaleVehicleAlbumResponseBodySaleVehiclePhoto = z.infer<
  typeof AddFilesToSaleVehicleAlbumResponseBodySchemaSaleVehiclePhoto
>;
export const AddFilesToSaleVehicleAlbumApiResponseSchemaSaleVehiclePhoto =
  AddFilesToSaleVehicleAlbumResponseBodySchemaSaleVehiclePhoto;
export type AddFilesToSaleVehicleAlbumApiResponseSaleVehiclePhoto = z.infer<
  typeof AddFilesToSaleVehicleAlbumApiResponseSchemaSaleVehiclePhoto
>;
export const AddFilesToSaleVehicleAlbumApiArgSchemaSaleVehiclePhoto = z.object({
  saleVehicleAlbumId: z.string(),
  addFilesToSaleVehicleAlbumRequestBody:
    AddFilesToSaleVehicleAlbumRequestBodySchemaSaleVehiclePhoto,
});
export type AddFilesToSaleVehicleAlbumApiArgSaleVehiclePhoto = z.infer<
  typeof AddFilesToSaleVehicleAlbumApiArgSchemaSaleVehiclePhoto
>;
export const SaleVehicleAlbumPhotoResponseBodySchemaSaleVehiclePhoto = z.object({
  id: z.string(),
  weight: z.number(),
  fileId: z.string(),
  remoteFileId: z.string(),
  isCoverPhoto: z.boolean(),
  url: z.string(),
  latestFileOperation: FileOperationResponseBodySchema.nullable(),
  category: VehiclePhotoCategorySchema.nullable(),
});
export type SaleVehicleAlbumPhotoResponseBodySaleVehiclePhoto = z.infer<
  typeof SaleVehicleAlbumPhotoResponseBodySchemaSaleVehiclePhoto
>;
export const GetSaleVehicleAlbumPhotoListApiResponseSchemaSaleVehiclePhoto = z.array(
  SaleVehicleAlbumPhotoResponseBodySchemaSaleVehiclePhoto
);
export type GetSaleVehicleAlbumPhotoListApiResponseSaleVehiclePhoto = z.infer<
  typeof GetSaleVehicleAlbumPhotoListApiResponseSchemaSaleVehiclePhoto
>;
export const GetSaleVehicleAlbumPhotoListApiArgSchemaSaleVehiclePhoto = z.object({
  saleVehicleId: z.string(),
  saleVehicleAlbumId: z.string(),
});
export type GetSaleVehicleAlbumPhotoListApiArgSaleVehiclePhoto = z.infer<
  typeof GetSaleVehicleAlbumPhotoListApiArgSchemaSaleVehiclePhoto
>;
export const DeleteSaleVehicleAlbumApiResponseSchemaSaleVehiclePhoto = z.undefined();
export type DeleteSaleVehicleAlbumApiResponseSaleVehiclePhoto = z.infer<
  typeof DeleteSaleVehicleAlbumApiResponseSchemaSaleVehiclePhoto
>;
export const DeleteSaleVehicleAlbumApiArgSchemaSaleVehiclePhoto = z.object({
  saleVehicleAlbumId: z.string(),
});
export type DeleteSaleVehicleAlbumApiArgSaleVehiclePhoto = z.infer<
  typeof DeleteSaleVehicleAlbumApiArgSchemaSaleVehiclePhoto
>;
export const SaleVehiclePhotoPositionDtoSchemaSaleVehiclePhoto = z.object({
  fileId: z.string(),
  position: z.number(),
});
export type SaleVehiclePhotoPositionDtoSaleVehiclePhoto = z.infer<
  typeof SaleVehiclePhotoPositionDtoSchemaSaleVehiclePhoto
>;
export const SaleVehiclePhotoCopyRequestBodySchemaSaleVehiclePhoto = z.object({
  photos: z.array(SaleVehiclePhotoPositionDtoSchemaSaleVehiclePhoto),
  sourceAlbum: z.string(),
  destinationAlbum: z.string(),
  position: z.number().nullable().optional(),
});
export type SaleVehiclePhotoCopyRequestBodySaleVehiclePhoto = z.infer<
  typeof SaleVehiclePhotoCopyRequestBodySchemaSaleVehiclePhoto
>;
export const CopySaleVehiclePhotoApiResponseSchemaSaleVehiclePhoto = z.unknown();
export type CopySaleVehiclePhotoApiResponseSaleVehiclePhoto = z.infer<
  typeof CopySaleVehiclePhotoApiResponseSchemaSaleVehiclePhoto
>;
export const CopySaleVehiclePhotoApiArgSchemaSaleVehiclePhoto = z.object({
  saleVehicleId: z.string(),
  saleVehiclePhotoCopyRequestBody: SaleVehiclePhotoCopyRequestBodySchemaSaleVehiclePhoto,
});
export type CopySaleVehiclePhotoApiArgSaleVehiclePhoto = z.infer<
  typeof CopySaleVehiclePhotoApiArgSchemaSaleVehiclePhoto
>;
export type RotateSaleVehiclePhotosRequestBodySaleVehiclePhoto = {
  saleVehiclePhotoIds: string[];
  angle: 90 | 180 | 270;
};
export const UuidResponseBodySaleVehiclePhotosSchemaSaleVehiclePhoto = z.object({
  id: z.string(),
});
export type UuidResponseBodySaleVehiclePhotosSaleVehiclePhoto = z.infer<
  typeof UuidResponseBodySaleVehiclePhotosSchemaSaleVehiclePhoto
>;
export const RotateSaleVehiclePhotosApiResponseSchemaSaleVehiclePhoto =
  UuidResponseBodySaleVehiclePhotosSchemaSaleVehiclePhoto;

export type RotateSaleVehiclePhotosApiResponseSaleVehiclePhoto = z.infer<
  typeof RotateSaleVehiclePhotosApiResponseSchemaSaleVehiclePhoto
>;
export type RotateSaleVehiclePhotosApiArgSaleVehiclePhoto = {
  saleVehicleId: string;
  saleVehicleAlbumId: string;
  rotateSaleVehiclePhotosRequestBody: RotateSaleVehiclePhotosRequestBodySaleVehiclePhoto;
};
export const SetSaleVehicleAlbumCoverPhotoApiResponseSchemaSaleVehiclePhoto = z.unknown();
export type SetSaleVehicleAlbumCoverPhotoApiResponseSaleVehiclePhoto = z.infer<
  typeof SetSaleVehicleAlbumCoverPhotoApiResponseSchemaSaleVehiclePhoto
>;
export const SetSaleVehicleAlbumCoverPhotoApiArgSchemaSaleVehiclePhoto = z.object({
  saleVehicleAlbumId: z.string(),
  saleVehiclePhotoId: z.string(),
});
export type SetSaleVehicleAlbumCoverPhotoApiArgSaleVehiclePhoto = z.infer<
  typeof SetSaleVehicleAlbumCoverPhotoApiArgSchemaSaleVehiclePhoto
>;
export const UnsetSaleVehicleAlbumCoverPhotoApiResponseSchemaSaleVehiclePhoto = z.unknown();
export type UnsetSaleVehicleAlbumCoverPhotoApiResponseSaleVehiclePhoto = z.infer<
  typeof UnsetSaleVehicleAlbumCoverPhotoApiResponseSchemaSaleVehiclePhoto
>;
export const UnsetSaleVehicleAlbumCoverPhotoApiArgSchemaSaleVehiclePhoto = z.object({
  saleVehicleAlbumId: z.string(),
});
export type UnsetSaleVehicleAlbumCoverPhotoApiArgSaleVehiclePhoto = z.infer<
  typeof UnsetSaleVehicleAlbumCoverPhotoApiArgSchemaSaleVehiclePhoto
>;
export const SaleVehicleAlbumByVehicleResponseBodySchemaSaleVehiclePhoto = z.object({
  translation: z.string(),
  id: z.string(),
  name: z.string(),
  createdAt: z.string(),
  saleVehicleId: z.string(),
  active: z.boolean(),
  saleVehicleCreatedAt: z.string(),
});
export type SaleVehicleAlbumByVehicleResponseBodySaleVehiclePhoto = z.infer<
  typeof SaleVehicleAlbumByVehicleResponseBodySchemaSaleVehiclePhoto
>;
export const ListSaleVehicleAlbumsByVehicleApiResponseSchemaSaleVehiclePhoto = z.array(
  SaleVehicleAlbumByVehicleResponseBodySchemaSaleVehiclePhoto
);
export type ListSaleVehicleAlbumsByVehicleApiResponseSaleVehiclePhoto = z.infer<
  typeof ListSaleVehicleAlbumsByVehicleApiResponseSchemaSaleVehiclePhoto
>;
export const ListSaleVehicleAlbumsByVehicleApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string().optional(),
});
export type ListSaleVehicleAlbumsByVehicleApiArgSaleVehiclePhoto = z.infer<
  typeof ListSaleVehicleAlbumsByVehicleApiArgSchemaSaleVehiclePhoto
>;
export const SaleVehiclePhotoDtoSchemaSaleVehiclePhoto = z.object({
  fileId: z.string(),
});
export type SaleVehiclePhotoDtoSaleVehiclePhoto = z.infer<
  typeof SaleVehiclePhotoDtoSchemaSaleVehiclePhoto
>;
export const SaleVehiclePhotoDeleteRequestBodySchemaSaleVehiclePhoto = z.object({
  photos: z.array(SaleVehiclePhotoDtoSchemaSaleVehiclePhoto),
});
export type SaleVehiclePhotoDeleteRequestBodySaleVehiclePhoto = z.infer<
  typeof SaleVehiclePhotoDeleteRequestBodySchemaSaleVehiclePhoto
>;
export const DeleteSaleVehiclePhotoApiResponseSchemaSaleVehiclePhoto = z.unknown();
export type DeleteSaleVehiclePhotoApiResponseSaleVehiclePhoto = z.infer<
  typeof DeleteSaleVehiclePhotoApiResponseSchemaSaleVehiclePhoto
>;
export const DeleteSaleVehiclePhotoApiArgSchemaSaleVehiclePhoto = z.object({
  saleVehicleId: z.string(),
  saleVehicleAlbumId: z.string(),
  saleVehiclePhotoDeleteRequestBody: SaleVehiclePhotoDeleteRequestBodySchemaSaleVehiclePhoto,
});
export type DeleteSaleVehiclePhotoApiArgSaleVehiclePhoto = z.infer<
  typeof DeleteSaleVehiclePhotoApiArgSchemaSaleVehiclePhoto
>;
export const SaleVehiclePhotoUpdateAlbumRequestBodySchemaSaleVehiclePhoto = z.object({
  photos: z.array(SaleVehiclePhotoPositionDtoSchemaSaleVehiclePhoto),
  sourceAlbum: z.string(),
  destinationAlbum: z.string(),
  position: z.number().nullish(),
});
export type SaleVehiclePhotoUpdateAlbumRequestBodySaleVehiclePhoto = z.infer<
  typeof SaleVehiclePhotoUpdateAlbumRequestBodySchemaSaleVehiclePhoto
>;
export const UpdateSaleVehiclePhotoAlbumApiResponseSchemaSaleVehiclePhoto = z.unknown();
export type UpdateSaleVehiclePhotoAlbumApiResponseSaleVehiclePhoto = z.infer<
  typeof UpdateSaleVehiclePhotoAlbumApiResponseSchemaSaleVehiclePhoto
>;
export const UpdateSaleVehiclePhotoAlbumApiArgSchemaSaleVehiclePhoto = z.object({
  saleVehiclePhotoUpdateAlbumRequestBody:
    SaleVehiclePhotoUpdateAlbumRequestBodySchemaSaleVehiclePhoto,
});
export type UpdateSaleVehiclePhotoAlbumApiArgSaleVehiclePhoto = z.infer<
  typeof UpdateSaleVehiclePhotoAlbumApiArgSchemaSaleVehiclePhoto
>;
export const DownloadGalleryResponseBodySchemaSaleVehiclePhoto = z.object({
  eventId: z.string(),
});
export type DownloadGalleryResponseBodySaleVehiclePhoto = z.infer<
  typeof DownloadGalleryResponseBodySchemaSaleVehiclePhoto
>;
export const DownloadSaleVehicleGalleryApiResponseSchemaSaleVehiclePhoto =
  DownloadGalleryResponseBodySchemaSaleVehiclePhoto;
export type DownloadSaleVehicleGalleryApiResponseSaleVehiclePhoto = z.infer<
  typeof DownloadSaleVehicleGalleryApiResponseSchemaSaleVehiclePhoto
>;
export const DownloadSaleVehicleGalleryApiArgSchemaSaleVehiclePhoto = z.object({
  saleVehicleId: z.string(),
  albumId: z.string().nullish(),
  watermarkId: z.string().nullish(),
});
export type DownloadSaleVehicleGalleryApiArgSaleVehiclePhoto = z.infer<
  typeof DownloadSaleVehicleGalleryApiArgSchemaSaleVehiclePhoto
>;
export const RemoveSaleVehiclePhotosBackgroundRequestBodySchemaSaleVehiclePhoto = z.object({
  saleVehiclePhotoIds: z.array(z.string()),
  backgroundRemovalSettingId: z.string().nullish(),
});
export type RemoveSaleVehiclePhotosBackgroundRequestBodySaleVehiclePhoto = z.infer<
  typeof RemoveSaleVehiclePhotosBackgroundRequestBodySchemaSaleVehiclePhoto
>;
export const RemoveSaleVehiclePhotosBackgroundApiResponseSchemaSaleVehiclePhoto =
  UuidResponseBodySchema;
export type RemoveSaleVehiclePhotosBackgroundApiResponseSaleVehiclePhoto = z.infer<
  typeof RemoveSaleVehiclePhotosBackgroundApiResponseSchemaSaleVehiclePhoto
>;
export const RemoveSaleVehiclePhotosBackgroundApiArgSchemaSaleVehiclePhoto = z.object({
  saleVehicleId: z.string(),
  saleVehicleAlbumId: z.string(),
  removeSaleVehiclePhotosBackgroundRequestBody:
    RemoveSaleVehiclePhotosBackgroundRequestBodySchemaSaleVehiclePhoto,
});

export type RemoveSaleVehiclePhotosBackgroundApiArgSaleVehiclePhoto = z.infer<
  typeof RemoveSaleVehiclePhotosBackgroundApiArgSchemaSaleVehiclePhoto
>;

export const GetSaleVehiclePreviewResponseBodySchemaSaleVehiclePhoto = z.object({
  content: z.string(),
});

export type GetSaleVehiclePreviewResponseBodySaleVehiclePhoto = z.infer<
  typeof GetSaleVehiclePreviewResponseBodySchemaSaleVehiclePhoto
>;

export const GetSaleVehiclePreviewApiResponseSchemaSaleVehiclePhoto =
  GetSaleVehiclePreviewResponseBodySchemaSaleVehiclePhoto;

export type GetSaleVehiclePreviewApiResponseSaleVehiclePhoto = z.infer<
  typeof GetSaleVehiclePreviewApiResponseSchemaSaleVehiclePhoto
>;
export const GetSaleVehiclePreviewApiArgSchemaSaleVehiclePhoto = z.object({
  saleVehiclePhotoId: z.string(),
});
export type GetSaleVehiclePreviewApiArgSaleVehiclePhoto = z.infer<
  typeof GetSaleVehiclePreviewApiArgSchemaSaleVehiclePhoto
>;

// PROMOTIONAL PHOTOS API
export const SaleVehiclePromoPhotoResponseBodySchemaSaleVehiclePhoto = z.object({
  id: z.string(),
  position: z.number(),
  positionInSettings: z.number(),
  fileId: z.string(),
  remoteFileId: z.string(),
  url: z.string(),
});
export type SaleVehiclePromoPhotoResponseBodySaleVehiclePhoto = z.infer<
  typeof SaleVehiclePromoPhotoResponseBodySchemaSaleVehiclePhoto
>;
export const AddToSaleVehicleRequestBodySchemaSaleVehiclePhoto = z.object({
  saleVehicleId: z.string(),
});
export type AddToSaleVehicleRequestBodySaleVehiclePhoto = z.infer<
  typeof AddToSaleVehicleRequestBodySchemaSaleVehiclePhoto
>;
export const AddToSaleVehicleApiResponseSchemaSaleVehiclePhoto = z.array(
  SaleVehiclePromoPhotoResponseBodySchemaSaleVehiclePhoto
);
export type AddToSaleVehicleApiResponseSaleVehiclePhoto = z.infer<
  typeof AddToSaleVehicleApiResponseSchemaSaleVehiclePhoto
>;
export const AddToSaleVehicleApiArgSchemaSaleVehiclePhoto = z.object({
  addToSaleVehicleRequestBody: AddToSaleVehicleRequestBodySchemaSaleVehiclePhoto,
});
export type AddToSaleVehicleApiArgSaleVehiclePhoto = z.infer<
  typeof AddToSaleVehicleApiArgSchemaSaleVehiclePhoto
>;
export const GetForSaleVehicleApiResponseSchemaSaleVehiclePhoto = z.array(
  SaleVehiclePromoPhotoResponseBodySchemaSaleVehiclePhoto
);
export type GetForSaleVehicleApiResponseSaleVehiclePhoto = z.infer<
  typeof GetForSaleVehicleApiResponseSchemaSaleVehiclePhoto
>;
export const GetForSaleVehicleApiArgSchemaSaleVehiclePhoto = z.object({
  saleVehicleId: z.string(),
});
export type GetForSaleVehicleApiArgSaleVehiclePhoto = z.infer<
  typeof GetForSaleVehicleApiArgSchemaSaleVehiclePhoto
>;
export const RemoveInSaleVehicleRequestBodySchemaSaleVehiclePhoto = z.object({
  saleVehiclePromoPhotoId: z.string(),
});
export type RemoveInSaleVehicleRequestBodySaleVehiclePhoto = z.infer<
  typeof RemoveInSaleVehicleRequestBodySchemaSaleVehiclePhoto
>;
export const UpdatePositionInSaleVehicleRequestBodySchemaSaleVehiclePhoto = z.object({
  saleVehiclePromoPhotoId: z.string(),
  position: z.number(),
});
export type UpdatePositionInSaleVehicleRequestBodySaleVehiclePhoto = z.infer<
  typeof UpdatePositionInSaleVehicleRequestBodySchemaSaleVehiclePhoto
>;
export const UpdatePositionsInSaleVehicleRequestBodySchemaSaleVehiclePhoto = z.object({
  positions: z.array(UpdatePositionInSaleVehicleRequestBodySchemaSaleVehiclePhoto),
});
export type UpdatePositionsInSaleVehicleRequestBodySaleVehiclePhoto = z.infer<
  typeof UpdatePositionsInSaleVehicleRequestBodySchemaSaleVehiclePhoto
>;
export const RemoveInSaleVehicleApiResponseSchemaSaleVehiclePhoto = z.unknown();
export type RemoveInSaleVehicleApiResponseSaleVehiclePhoto = z.infer<
  typeof RemoveInSaleVehicleApiResponseSchemaSaleVehiclePhoto
>;
export const RemoveInSaleVehicleApiArgSchemaSaleVehiclePhoto = z.object({
  removeInSaleVehicleRequestBody: RemoveInSaleVehicleRequestBodySchemaSaleVehiclePhoto,
});
export type RemoveInSaleVehicleApiArgSaleVehiclePhoto = z.infer<
  typeof RemoveInSaleVehicleApiArgSchemaSaleVehiclePhoto
>;
export const SaleVehicleCoverPhotoResponseBodySchemaSaleVehiclePhoto = z.object({
  id: z.string(),
  fileId: z.string(),
  remoteFileId: z.string(),
  saleVehicleAlbumId: z.string(),
  uri: z.string(),
});
export type SaleVehicleCoverPhotoResponseBodySaleVehiclePhoto = z.infer<
  typeof SaleVehicleCoverPhotoResponseBodySchemaSaleVehiclePhoto
>;
export const GetSaleVehicleCoverPhotoApiResponseSchemaSaleVehiclePhoto =
  SaleVehicleCoverPhotoResponseBodySchemaSaleVehiclePhoto;
export type GetSaleVehicleCoverPhotoApiResponseSaleVehiclePhoto = z.infer<
  typeof GetSaleVehicleCoverPhotoApiResponseSchemaSaleVehiclePhoto
>;
export const GetSaleVehicleCoverPhotoApiArgSchemaSaleVehiclePhoto = z.object({
  saleVehicleId: z.string(),
});
export type GetSaleVehicleCoverPhotoApiArgSaleVehiclePhoto = z.infer<
  typeof GetSaleVehicleCoverPhotoApiArgSchemaSaleVehiclePhoto
>;
export const UpdatePositionsInSaleVehicleApiResponseSchemaSaleVehiclePhoto = z.unknown();
export type UpdatePositionsInSaleVehicleApiResponseSaleVehiclePhoto = z.infer<
  typeof UpdatePositionsInSaleVehicleApiResponseSchemaSaleVehiclePhoto
>;
export const UpdatePositionsInSaleVehicleApiArgSchemaSaleVehiclePhoto = z.object({
  updatePositionsInSaleVehicleRequestBody:
    UpdatePositionsInSaleVehicleRequestBodySchemaSaleVehiclePhoto,
});
export type UpdatePositionsInSaleVehicleApiArgSaleVehiclePhoto = z.infer<
  typeof UpdatePositionsInSaleVehicleApiArgSchemaSaleVehiclePhoto
>;
export const ResetPositionsInSaleVehicleRequestBodySchemaSaleVehiclePhoto = z.object({
  saleVehicleId: z.string(),
});
export type ResetPositionsInSaleVehicleRequestBodySaleVehiclePhoto = z.infer<
  typeof ResetPositionsInSaleVehicleRequestBodySchemaSaleVehiclePhoto
>;
export const ResetPositionsInSaleVehicleApiResponseSchemaSaleVehiclePhoto = z.array(
  SaleVehiclePromoPhotoResponseBodySchemaSaleVehiclePhoto
);
export type ResetPositionsInSaleVehicleApiResponseSaleVehiclePhoto = z.infer<
  typeof ResetPositionsInSaleVehicleApiResponseSchemaSaleVehiclePhoto
>;
export const ResetPositionsInSaleVehicleApiArgSchemaSaleVehiclePhoto = z.object({
  resetPositionsInSaleVehicleRequestBody:
    ResetPositionsInSaleVehicleRequestBodySchemaSaleVehiclePhoto,
});
export type ResetPositionsInSaleVehicleApiArgSaleVehiclePhoto = z.infer<
  typeof ResetPositionsInSaleVehicleApiArgSchemaSaleVehiclePhoto
>;
export const SaleVehiclePhotoListResponseBodySchemaSaleVehiclePhoto = z.object({
  photos: z.array(SaleVehiclePhotoResponseBodySchemaSaleVehiclePhoto),
});
export type SaleVehiclePhotoListResponseBodySaleVehiclePhoto = z.infer<
  typeof SaleVehiclePhotoListResponseBodySchemaSaleVehiclePhoto
>;
export const GetSaleVehiclePhotoListApiResponseSchemaSaleVehiclePhoto =
  SaleVehiclePhotoListResponseBodySchemaSaleVehiclePhoto;
export type GetSaleVehiclePhotoListApiResponseSaleVehiclePhoto = z.infer<
  typeof GetSaleVehiclePhotoListApiResponseSchemaSaleVehiclePhoto
>;
export const GetSaleVehiclePhotoListApiArgSchemaSaleVehiclePhoto = z.object({
  saleVehicleId: z.string(),
});
export type GetSaleVehiclePhotoListApiArgSaleVehiclePhoto = z.infer<
  typeof GetSaleVehiclePhotoListApiArgSchemaSaleVehiclePhoto
>;
export const SaleVehicleAuditPhotoCopyRequestBodySchemaSaleVehiclePhoto = z.object({
  auditId: z.string(),
  auditCategoryId: z.string(),
  saleVehicleAlbumId: z.string(),
});
export type SaleVehicleAuditPhotoCopyRequestBodySaleVehiclePhoto = z.infer<
  typeof SaleVehicleAuditPhotoCopyRequestBodySchemaSaleVehiclePhoto
>;
export const CopyAuditPhotoToSaleVehicleAlbumApiResponseSchemaSaleVehiclePhoto = z.unknown();
export type CopyAuditPhotoToSaleVehicleAlbumApiResponseSaleVehiclePhoto = z.infer<
  typeof CopyAuditPhotoToSaleVehicleAlbumApiResponseSchemaSaleVehiclePhoto
>;
export const CopyAuditPhotoToSaleVehicleAlbumApiArgSchemaSaleVehiclePhoto = z.object({
  saleVehicleId: z.string(),
  saleVehicleAuditPhotoCopyRequestBody: SaleVehicleAuditPhotoCopyRequestBodySchemaSaleVehiclePhoto,
});

export type CopyAuditPhotoToSaleVehicleAlbumApiArgSaleVehiclePhoto = z.infer<
  typeof CopyAuditPhotoToSaleVehicleAlbumApiArgSchemaSaleVehiclePhoto
>;
export const ListSaleVehiclePhotosByVehicleApiResponseSchemaSaleVehiclePhoto =
  SaleVehiclePhotoListResponseBodySchemaSaleVehiclePhoto;
export type ListSaleVehiclePhotosByVehicleApiResponseSaleVehiclePhoto = z.infer<
  typeof ListSaleVehiclePhotosByVehicleApiResponseSchemaSaleVehiclePhoto
>;
export const ListSaleVehiclePhotosByVehicleApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string().optional(),
});
export type ListSaleVehiclePhotosByVehicleApiArgSaleVehiclePhoto = z.infer<
  typeof ListSaleVehiclePhotosByVehicleApiArgSchemaSaleVehiclePhoto
>;
export const PatchSaleVehicleSalePresetRequestBodySchemaSaleVehiclePhoto = z.object({
  salePresetId: z.string().nullable(),
});

export const PatchSaleVehicleSalePresetApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
  patchSaleVehicleSalePresetRequestBody:
    PatchSaleVehicleSalePresetRequestBodySchemaSaleVehiclePhoto,
});

export type PatchSaleVehicleSalePresetRequestBodySaleVehiclePhoto = z.infer<
  typeof PatchSaleVehicleSalePresetRequestBodySchemaSaleVehiclePhoto
>;
export type PatchSaleVehicleSalePresetApiArgSaleVehiclePhoto = z.infer<
  typeof PatchSaleVehicleSalePresetApiArgSchemaSaleVehiclePhoto
>;
export type PatchSaleVehicleSalePresetApiResponseSaleVehiclePhoto = unknown;
export const PatchSaleVehicleWatermarkApiResponseSchemaSaleVehiclePhoto = z.unknown();
export type PatchSaleVehicleWatermarkApiResponseSaleVehiclePhoto = z.infer<
  typeof PatchSaleVehicleWatermarkApiResponseSchemaSaleVehiclePhoto
>;
export const PatchSaleVehicleWatermarkRequestBodySchemaSaleVehiclePhoto = z.object({
  watermarkId: z.string().nullable(),
});
export type PatchSaleVehicleWatermarkRequestBodySaleVehiclePhoto = z.infer<
  typeof PatchSaleVehicleWatermarkRequestBodySchemaSaleVehiclePhoto
>;
export const PatchSaleVehicleWatermarkApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
  patchSaleVehicleWatermarkRequestBody: PatchSaleVehicleWatermarkRequestBodySchemaSaleVehiclePhoto,
});
export type PatchSaleVehicleWatermarkApiArgSaleVehiclePhoto = z.infer<
  typeof PatchSaleVehicleWatermarkApiArgSchemaSaleVehiclePhoto
>;

export const VehicleCostCategoryResponseBodySchemaSaleVehiclePhoto = z.array(
  z.object({
    key: z.string(),
    name: z.string(),
  })
);
export type ListVehicleCostCategoriesApiResponseSaleVehiclePhoto = z.infer<
  typeof VehicleCostCategoryResponseBodySchemaSaleVehiclePhoto
>;

export const ListVehicleCostCategoriesApiArgSchemaSaleVehiclePhoto = z.object({});
export type ListVehicleCostCategoriesApiArgSaleVehiclePhoto = z.infer<
  typeof ListVehicleCostCategoriesApiArgSchemaSaleVehiclePhoto
>;

export const PatchSaleVehiclePhotosCategoryRequestBodySchemaSaleVehiclePhoto = z.object({
  saleVehiclePhotoIds: z.array(z.string()),
  category: VehiclePhotoCategorySchema.nullable(),
});
export type PatchSaleVehiclePhotosCategoryRequestBodySaleVehiclePhoto = z.infer<
  typeof PatchSaleVehiclePhotosCategoryRequestBodySchemaSaleVehiclePhoto
>;

export type PatchSaleVehiclePhotosCategoryApiResponseSaleVehiclePhoto = /** status 204  */ void;
export type PatchSaleVehiclePhotosCategoryApiArgSaleVehiclePhoto = {
  saleVehicleId: string;
  saleVehicleAlbumId: string;
  patchSaleVehiclePhotosCategoryRequestBody: PatchSaleVehiclePhotosCategoryRequestBodySaleVehiclePhoto;
};

export const OneTimePriceSchemaSaleVehiclePhoto = z.object({
  vatType: z.string(),
  vatRate: BigDecimalSchema,
  withoutVat: MoneySchema,
  withVat: MoneySchema,
  vatDirection: z.enum(['FROM_PRICE_WITHOUT_VAT', 'FROM_PRICE_WITH_VAT']),
});

export const RecurringPriceSimpleSchemaSaleVehiclePhoto = z.object({
  startDate: z.string(),
  endDate: z.string().nullable(),
  price: MoneySchema,
});

export const RecurringPriceCalculatedSchemaSaleVehiclePhoto = z.object({
  startDate: z.string(),
  endDate: z.string().nullable(),
  basePrice: MoneySchema,
  interestRate: BigDecimalSchema,
});

export const VehicleCostRequestBodySchemaSaleVehiclePhoto = z.object({
  name: z.string(),
  category: z.string().nullable(),
  expectedPrice: OneTimePriceSchemaSaleVehiclePhoto.nullable(),
  realPriceOneTime: OneTimePriceSchemaSaleVehiclePhoto.nullable(),
  realPriceRecurringSimple: RecurringPriceSimpleSchemaSaleVehiclePhoto.nullable(),
  realPriceRecurringCalculated: RecurringPriceCalculatedSchemaSaleVehiclePhoto.nullable(),
  note: z.string().nullable(),
  fileId: z.string().nullable(),
});

export const VehicleCostResponseBodySchemaSaleVehiclePhoto = z.object({
  id: z.string(),
  name: z.string(),
  category: z.string().nullable(),
  expectedPrice: OneTimePriceSchemaSaleVehiclePhoto.nullable(),
  realPriceOneTime: OneTimePriceSchemaSaleVehiclePhoto.nullable(),
  realPriceRecurringSimple: RecurringPriceSimpleSchemaSaleVehiclePhoto.nullable(),
  realPriceRecurringCalculated: RecurringPriceCalculatedSchemaSaleVehiclePhoto.nullable(),
  note: z.string().nullable(),
  fileId: z.string().nullable(),
});

export const AddVehicleCostApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
  addVehicleCostRequestBody: VehicleCostRequestBodySchemaSaleVehiclePhoto,
});

export const GetVehicleCostApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
  costId: z.string(),
});

export const UpdateVehicleCostApiResponseSchemaSaleVehiclePhoto = z.unknown();

export const UpdateVehicleCostApiArgSchemaSaleVehiclePhoto = z.object({
  vehicleId: z.string(),
  costId: z.string(),
  updateVehicleCostRequestBody: VehicleCostRequestBodySchemaSaleVehiclePhoto,
});

export type OneTimePriceSaleVehiclePhoto = z.infer<typeof OneTimePriceSchemaSaleVehiclePhoto>;
export type RecurringPriceSimpleSaleVehiclePhoto = z.infer<
  typeof RecurringPriceSimpleSchemaSaleVehiclePhoto
>;
export type RecurringPriceCalculatedSaleVehiclePhoto = z.infer<
  typeof RecurringPriceCalculatedSchemaSaleVehiclePhoto
>;
export type AddVehicleCostRequestBodySaleVehiclePhoto = z.infer<
  typeof VehicleCostRequestBodySchemaSaleVehiclePhoto
>;
export type VehicleCostResponseBodySaleVehiclePhoto = z.infer<
  typeof VehicleCostResponseBodySchemaSaleVehiclePhoto
>;
export type AddVehicleCostApiArgSaleVehiclePhoto = z.infer<
  typeof AddVehicleCostApiArgSchemaSaleVehiclePhoto
>;
export type GetVehicleCostApiArgSaleVehiclePhoto = z.infer<
  typeof GetVehicleCostApiArgSchemaSaleVehiclePhoto
>;
export type GetVehicleCostApiResponseSaleVehiclePhoto = VehicleCostResponseBodySaleVehiclePhoto;

export const AddVehicleCostApiResponseSchemaSaleVehiclePhoto = UuidResponseBodySchema;
export type AddVehicleCostApiResponseSaleVehiclePhoto = z.infer<
  typeof AddVehicleCostApiResponseSchemaSaleVehiclePhoto
>;

export type UpdateVehicleCostApiResponseSaleVehiclePhoto = z.infer<
  typeof UpdateVehicleCostApiResponseSchemaSaleVehiclePhoto
>;
export type UpdateVehicleCostApiArgSaleVehiclePhoto = z.infer<
  typeof UpdateVehicleCostApiArgSchemaSaleVehiclePhoto
>;
